<style>
  .header-main {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000 !important;
    background: #E4F7F8 !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    transition: all 0.3s ease;
  }

  /* Force lower z-index on competing elements */
  ::ng-deep .search-area,
  ::ng-deep .search-btn,
  ::ng-deep .theme-btn,
  ::ng-deep .modifiysearch,
  ::ng-deep .flight-search {
    z-index: 1 !important;
  }

  .nav-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 84px;
    padding: 0 24px;
    max-width: 1400px;
    margin: 0 auto;
  }

  .nav-left,
  .nav-right {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .nav-center {
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: center;
    padding: 0 40px;
  }

  /* Logo */
  .brand-logo {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .brand-logo img {
    height: 78px;
    width: auto;
    object-fit: contain;
  }

  /* Main Navigation Links */
  .nav-links {
    display: flex;
    align-items: center;
    gap: 4px;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .nav-link-item {
    position: relative;
  }

  .nav-link-anchor {
    color: #475569;
    font-size: 14px;
    font-weight: 700;
    padding: 8px 16px;
    border-radius: 8px;
    text-decoration: none !important;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .nav-link-anchor:hover {
    color: #24BDC7;
    background: rgba(36, 189, 199, 0.05);
  }

  .nav-link-anchor i {
    font-size: 10px;
    opacity: 0.5;
  }

  /* Dropdowns */
  .nav-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    background: #ffffff;
    min-width: 200px;
    border-radius: 12px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
    border: 1px solid #f1f5f9;
    padding: 8px;
    opacity: 0;
    visibility: hidden;
    transform: translateY(10px);
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .nav-link-item:hover .nav-dropdown {
    opacity: 1;
    visibility: visible;
    transform: translateY(4px);
  }

  .dropdown-item-link {
    color: #475569;
    font-size: 13px;
    font-weight: 600;
    padding: 10px 14px;
    border-radius: 8px;
    text-decoration: none !important;
    display: block;
    transition: all 0.2s;
  }

  .dropdown-item-link:hover {
    background: rgba(36, 189, 199, 0.08);
    color: #24BDC7;
    padding-left: 18px;
  }

  /* User Profile & Actions */
  .user-pill {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 6px 6px 6px 14px;
    background: #ffffff;
    border: 1px solid #f1f5f9;
    border-radius: 30px;
    cursor: pointer;
    transition: all 0.2s;
    position: relative;
  }

  .user-pill:hover {
    background: #ffffff;
    border-color: #24BDC7;
    box-shadow: 0 4px 12px rgba(36, 189, 199, 0.1);
  }

  .user-info-text {
    display: flex;
    flex-direction: column;
    text-align: right;
  }

  .user-name {
    font-size: 12px;
    font-weight: 800;
    color: #1e293b;
    white-space: nowrap;
  }

  .user-credit-limit {
    font-size: 10px;
    font-weight: 600;
    color: #64748b;
    white-space: nowrap;
  }

  .user-balance {
    font-size: 11px;
    font-weight: 700;
    white-space: nowrap;
  }

  .user-balance.balance-positive {
    color: #16a34a;
  }

  .user-balance.balance-on-credit {
    color: #dc2626;
  }

  .user-avatar {
    width: 32px;
    height: 32px;
    background: #24BDC7;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    font-size: 12px;
  }

  .utility-action {
    color: #64748b;
    font-size: 14px;
    padding: 10px;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .utility-action:hover {
    background: #f1f5f9;
    color: #24BDC7;
  }

  /* Profile Dropdown Custom */
  .profile-menu {
    right: 0;
    left: auto;
    width: 240px;
    padding: 12px;
  }

  .profile-menu-header {
    padding: 4px 12px 12px;
    margin-bottom: 8px;
    border-bottom: 1px solid #f1f5f9;
  }

  .profile-menu-title {
    font-size: 14px;
    font-weight: 800;
    color: #1e293b;
  }

  .profile-menu-email {
    font-size: 11px;
    color: #64748b;
  }

  .logout-btn {
    color: #ef4444;
  }

  .logout-btn:hover {
    background: rgba(239, 68, 68, 0.05);
    color: #ef4444;
  }

  /* Language Selector */
  .lang-selector {
    padding: 8px 12px;
    border-radius: 8px;
    background: #ffffff;
    font-size: 12px;
    font-weight: 700;
    color: #1e293b;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s;
  }

  .lang-selector:hover {
    background: #f1f5f9;
  }

  /* Mobile */
  @media (max-width: 991px) {
    .nav-center {
      display: none;
    }

    .nav-right {
      gap: 4px;
    }
  }

  /* Mobile Menu Styles */
  .mobile-menu-overlay {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #E4F7F8;
    box-shadow: 0 10px 25px rgba(0,0,0,0.15);
    display: none;
    flex-direction: column;
    padding: 16px;
    z-index: 9999;
    max-height: calc(100vh - 84px);
    overflow-y: auto;
    border-bottom: 2px solid #24BDC7;
  }

  .mobile-menu-overlay.open {
    display: flex;
    animation: slideDown 0.3s ease-out;
  }

  .mobile-menu-item {
    padding: 10px 8px;
    border-bottom: 1px solid rgba(0,0,0,0.06);
  }
  
  .mobile-menu-item:last-child {
    border-bottom: none;
  }
  
  .mobile-menu-link {
    color: #1e293b;
    font-size: 14px;
    font-weight: 700;
    text-decoration: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .mobile-dropdown {
    padding-left: 16px;
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .mobile-dropdown-link {
    color: #475569;
    font-size: 13.5px;
    text-decoration: none;
    padding: 6px 0;
  }
</style>

<header class="header-main">
  <div class="nav-container">

    <!-- Left: Logo & Home -->
    <div class="nav-left">
      <div class="brand-logo" (click)="onHomeClick()">
        <img [src]="agencyLogoUrl" alt="logo" >
      </div>
    </div>

    <!-- Center: Dynamic Menus -->
    <div class="nav-center">
      <ul class="nav-links">
        <li class="nav-link-item">
          <a class="nav-link-anchor" (click)="onHomeClick()" style="cursor: pointer;">
            {{ 'Home' | lang }}
          </a>
        </li>
        <li class="nav-link-item" *ngFor="let menu of menuTree">
          <a class="nav-link-anchor" href="javascript:void(0)">
            {{ (menu.menuName | lang) | titlecase }}
            <i class="fas fa-chevron-down" *ngIf="menu.children?.length"></i>
          </a>

          <div class="nav-dropdown" *ngIf="menu.children?.length">
            <a class="dropdown-item-link" *ngFor="let child of menu.children" [routerLink]="child.url">
              {{ (child.menuName | lang) | titlecase }}
            </a>
          </div>
        </li>
      </ul>
    </div>

    <!-- Right: Language, Settings, Profile -->
    <div class="nav-right">

      <!-- Language -->
      <div class="nav-link-item d-none d-md-block">
        <div class="lang-selector">
          <i class="fas fa-globe"></i>
          {{selectedLanguage}}
        </div>
        <div class="nav-dropdown" style="min-width: 120px; left: auto; right: 0;">
          <a class="dropdown-item-link" *ngFor="let language of sortedLanguages" (click)="selectLanguage(language)">
            {{ language.lang }}
          </a>
        </div>
      </div>

      <!-- User Profile -->
      <div class="nav-link-item">
        <div class="user-pill">
          <div class="user-info-text d-none d-sm-flex">
            <span class="user-name">{{userData?.FirstName}} {{userData?.LastName}}</span>
            <span class="user-credit-limit">{{'Credit Limit' | lang}}: {{agencyCreditLimit | number:'1.2-2'}} {{agencyCurrency}}</span>
            <span class="user-balance" [ngClass]="isBalanceOnCredit ? 'balance-on-credit' : 'balance-positive'">
              {{'Balance' | lang}}: {{agencyNetBalance | number:'1.2-2'}} {{agencyCurrency}}
            </span>
          </div>
          <div class="user-avatar">
            {{userData?.FirstName?.charAt(0)}}{{userData?.LastName?.charAt(0)}}
          </div>
        </div>

        <div class="nav-dropdown profile-menu">
          <div class="profile-menu-header">
            <div class="profile-menu-title">{{'Account Settings' | lang}}</div>
            <div class="profile-menu-email">{{'Manage your profile & security' | lang}}</div>
          </div>

          <a class="dropdown-item-link" routerLink="/admin/bookings">
            <i class="far fa-ticket me-2"></i> {{'My Bookings' | lang}}
          </a>
          <a class="dropdown-item-link" routerLink="/admin/profile">
            <i class="far fa-user me-2"></i> {{'My Profile' | lang}}
          </a>
          <a class="dropdown-item-link" (click)="getBalance()" style="cursor: pointer;">
            <i class="far fa-sync me-2"></i> {{'Refresh Balance' | lang}}
          </a>

          <hr style="margin: 8px -12px; border-top: 1px solid #f1f5f9;">

          <a class="dropdown-item-link logout-btn" (click)="logout()" style="cursor: pointer;">
            <i class="far fa-sign-out me-2"></i> {{'Logout' | lang}}
          </a>
        </div>
      </div>

      <!-- Mobile Menu Toggle -->
      <button class="utility-action d-lg-none" type="button" (click)="toggleMobileMenu()" aria-label="Toggle Navigation">
        <i class="far" [ngClass]="isMobileMenuOpen ? 'fa-times' : 'fa-bars'"></i>
      </button>

    </div>

  </div>

  <!-- Mobile Menu Dropdown -->
  <div class="mobile-menu-overlay d-lg-none" [class.open]="isMobileMenuOpen">
    
    <!-- User Info Pill in mobile menu -->
    <div class="mobile-user-card p-2.5 mb-2 rounded-3 bg-white" style="border: 1px solid rgba(36, 189, 199, 0.25); padding: 10px 12px;">
      <div class="d-flex align-items-center gap-2 mb-2">
        <div class="user-avatar" style="width: 34px; height: 34px; font-size: 12px; flex-shrink: 0;">
          {{userData?.FirstName?.charAt(0)}}{{userData?.LastName?.charAt(0)}}
        </div>
        <div style="min-width: 0;">
          <div class="fw-bold text-truncate" style="font-size: 13px; color: #1e293b;">{{userData?.FirstName}} {{userData?.LastName}}</div>
          <div class="text-truncate" style="font-size: 11px; color: #64748b;">{{userData?.Email || userData?.AgencyName || ''}}</div>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center pt-2 border-top" style="border-color: #f1f5f9 !important; font-size: 11.5px;">
        <span class="text-muted">{{'Balance' | lang}}:</span>
        <span class="fw-bold" [ngClass]="isBalanceOnCredit ? 'text-danger' : 'text-success'">
          {{agencyNetBalance | number:'1.2-2'}} {{agencyCurrency}}
        </span>
      </div>
    </div>

    <!-- Navigation items -->
    <div class="mobile-menu-item">
      <a class="mobile-menu-link" (click)="onHomeClick(); toggleMobileMenu()" style="cursor: pointer;">
        <span><i class="far fa-home me-2" style="color: #24BDC7;"></i> {{ 'Home' | lang }}</span>
      </a>
    </div>

    <div class="mobile-menu-item" *ngFor="let menu of menuTree">
      <a class="mobile-menu-link" href="javascript:void(0)">
        <span>{{ (menu.menuName | lang) | titlecase }}</span>
        <i class="fas fa-chevron-down" *ngIf="menu.children?.length"></i>
      </a>
      <div class="mobile-dropdown" *ngIf="menu.children?.length">
        <a class="mobile-dropdown-link" *ngFor="let child of menu.children" [routerLink]="child.url" (click)="toggleMobileMenu()">
          {{ (child.menuName | lang) | titlecase }}
        </a>
      </div>
    </div>

    <!-- Account Links -->
    <div class="mobile-menu-item">
      <a class="mobile-menu-link" routerLink="/admin/bookings" (click)="toggleMobileMenu()">
        <span><i class="far fa-ticket me-2" style="color: #24BDC7;"></i> {{ 'My Bookings' | lang }}</span>
      </a>
    </div>

    <div class="mobile-menu-item">
      <a class="mobile-menu-link" routerLink="/admin/profile" (click)="toggleMobileMenu()">
        <span><i class="far fa-user me-2" style="color: #24BDC7;"></i> {{ 'My Profile' | lang }}</span>
      </a>
    </div>

    <!-- Language Selector Mobile -->
    <div class="mobile-menu-item d-flex align-items-center justify-content-between">
      <span class="mobile-menu-link"><i class="far fa-globe me-2" style="color: #24BDC7;"></i> {{ 'Language' | lang }}</span>
      <div class="d-flex gap-1">
        <button *ngFor="let language of languages" 
          type="button"
          class="btn btn-sm" 
          [ngStyle]="selectedLanguage === language.lang ? {'background': '#24BDC7', 'color': '#fff', 'border': 'none'} : {'background': '#fff', 'color': '#475569', 'border': '1px solid #cbd5e1'}"
          style="font-size: 11px; padding: 2px 8px; border-radius: 6px; font-weight: 600;"
          (click)="selectLanguage(language); toggleMobileMenu()">
          {{ language.lang }}
        </button>
      </div>
    </div>

    <!-- Logout Button -->
    <div class="mobile-menu-item mt-2 pt-2 border-top" style="border-top: 1px solid rgba(239, 68, 68, 0.2) !important;">
      <a class="mobile-menu-link text-danger fw-bold" (click)="logout(); toggleMobileMenu()" style="cursor: pointer;">
        <span><i class="far fa-sign-out me-2"></i> {{ 'Logout' | lang }}</span>
      </a>
    </div>

  </div>
</header>